export default __webpack_public_path__ + "static/media/TITULO_DISCO_07.71a200e3.png";